import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { formatINR } from "@/data/products";

const STATUSES = ["", "created", "paid", "processing", "shipped", "delivered", "cancelled", "failed"];

const Orders = () => {
  const [status, setStatus] = useState("");
  const { data, isLoading } = useQuery({
    queryKey: ["admin-orders", status],
    queryFn: async () => (await api.get("/admin/orders", { params: status ? { status } : {} })).data,
  });

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-serif-lux text-3xl">Orders</h1>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="border border-[#EBE8E3] rounded-lg px-4 py-2 text-sm bg-white">
          {STATUSES.map((s) => (
            <option key={s} value={s}>{s ? s[0].toUpperCase() + s.slice(1) : "All statuses"}</option>
          ))}
        </select>
      </div>

      {isLoading ? null : (
        <div className="border border-[#EBE8E3] rounded-lg overflow-hidden bg-white">
          <table className="w-full text-sm">
            <thead className="bg-[#F9F8F6] text-[#5C5C5C] text-[11px] uppercase tracking-wide">
              <tr>
                <th className="text-left px-5 py-3">Order</th>
                <th className="text-left px-5 py-3">Customer</th>
                <th className="text-left px-5 py-3">Total</th>
                <th className="text-left px-5 py-3">Status</th>
                <th className="text-left px-5 py-3">Date</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#EBE8E3]">
              {(data?.orders || []).map((o) => (
                <tr key={o._id} className="hover:bg-[#F9F8F6]">
                  <td className="px-5 py-3"><Link to={`/admin/orders/${o._id}`} className="text-[#C07C5F]">{o.orderNumber}</Link></td>
                  <td className="px-5 py-3">{o.user?.name}<br /><span className="text-xs text-[#5C5C5C]">{o.user?.email}</span></td>
                  <td className="px-5 py-3">{formatINR(o.total)}</td>
                  <td className="px-5 py-3 capitalize">{o.status}</td>
                  <td className="px-5 py-3">{new Date(o.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
              {(data?.orders || []).length === 0 && (
                <tr><td colSpan={5} className="px-5 py-8 text-center text-[#5C5C5C]">No orders found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Orders;
